import { jsx as g } from "@emotion/react/jsx-runtime";
import { css as m } from "@emotion/react";
import { ActionIcon as d, Icon as e, desktopFirstMediaQuery as u } from "@inflearn/ds-react";
import { as as Z, al as C } from "./StickyHeaderSkeleton-1e9bc44c.mjs";
import "react";
import "react/jsx-runtime";
import "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/ko";
import "dayjs/plugin/localizedFormat";
import "dayjs/plugin/updateLocale";
import "@inflearn/analytics";
import "@tanstack/react-query";
import "@inflearn/datasource-rest";
var o = {};
(function(c) {
  Object.defineProperty(c, "__esModule", { value: !0 });
  var b = "far", I = "angle-up", l = 448, n = 512, i = [8963], a = "f106", t = "M207 143c9.4-9.4 24.6-9.4 33.9 0L401 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-143-143L81 337c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 143z";
  c.definition = {
    prefix: b,
    iconName: I,
    icon: [
      l,
      n,
      i,
      a,
      t
    ]
  }, c.faAngleUp = c.definition, c.prefix = b, c.iconName = I, c.width = l, c.height = n, c.ligatures = i, c.unicode = a, c.svgPathData = t, c.aliases = i;
})(o);
const G = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
};
function f({
  isAntMan: c
}) {
  return /* @__PURE__ */ g(d, { "aria-label": "move-to-top", variant: "default", size: 42, radius: "md", tabIndex: Z.MOVE_TOP, onClick: G, mr: 16, css: s({
    isAntMan: c
  }), children: /* @__PURE__ */ g(e, { icon: o.faAngleUp, color: "dark", size: "md" }) });
}
const s = ({
  isAntMan: c
}) => /* @__PURE__ */ m({
  position: "fixed",
  zIndex: C(c).MOVE_TOP,
  bottom: "72px",
  left: "32px",
  [u.tablet]: {
    display: "none"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:styleButton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9jb21wb25lbnRzL0Zsb2F0aW5nQnV0dG9uL01vdmVUb3AudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQStCRSIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9mZS1zaGFyZWQvZmUtc2hhcmVkL3BhY2thZ2VzL2FwcC1zaGVsbC9zcmMvY29tcG9uZW50cy9GbG9hdGluZ0J1dHRvbi9Nb3ZlVG9wLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IEFjdGlvbkljb24sIGRlc2t0b3BGaXJzdE1lZGlhUXVlcnksIEljb24gfSBmcm9tICdAaW5mbGVhcm4vZHMtcmVhY3QnO1xuaW1wb3J0IHsgcmVndWxhciB9IGZyb20gJ0BpbmZsZWFybi9mb250YXdlc29tZS1zdmctY29yZS9pbXBvcnQubWFjcm8nO1xuXG5pbXBvcnQgeyBnZXRaSW5kZXggfSBmcm9tICcuLi8uLi9zdHlsZXMnO1xuaW1wb3J0IHsgVEFCX0lOREVYIH0gZnJvbSAnLi4vbmV4dC9IZWFkZXIvY29uc3RhbnRzL3RhYkluZGV4JztcblxuY29uc3QgaGFuZGxlTW92ZVRvcCA9ICgpID0+IHtcbiAgd2luZG93LnNjcm9sbFRvKHtcbiAgICB0b3A6IDAsXG4gICAgYmVoYXZpb3I6ICdzbW9vdGgnLFxuICB9KTtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIE1vdmVUb3AoeyBpc0FudE1hbiB9OiB7IGlzQW50TWFuOiBib29sZWFuIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8QWN0aW9uSWNvblxuICAgICAgYXJpYS1sYWJlbD1cIm1vdmUtdG8tdG9wXCJcbiAgICAgIHZhcmlhbnQ9XCJkZWZhdWx0XCJcbiAgICAgIHNpemU9ezQyfVxuICAgICAgcmFkaXVzPVwibWRcIlxuICAgICAgdGFiSW5kZXg9e1RBQl9JTkRFWC5NT1ZFX1RPUH1cbiAgICAgIG9uQ2xpY2s9e2hhbmRsZU1vdmVUb3B9XG4gICAgICBtcj17MTZ9XG4gICAgICBjc3M9e3N0eWxlQnV0dG9uKHsgaXNBbnRNYW4gfSl9PlxuICAgICAgPEljb24gaWNvbj17cmVndWxhcignYW5nbGUtdXAnKX0gY29sb3I9XCJkYXJrXCIgc2l6ZT1cIm1kXCIgLz5cbiAgICA8L0FjdGlvbkljb24+XG4gICk7XG59XG5cbmNvbnN0IHN0eWxlQnV0dG9uID0gKHsgaXNBbnRNYW4gfTogeyBpc0FudE1hbjogYm9vbGVhbiB9KSA9PlxuICBjc3Moe1xuICAgIHBvc2l0aW9uOiAnZml4ZWQnLFxuICAgIHpJbmRleDogZ2V0WkluZGV4KGlzQW50TWFuKS5NT1ZFX1RPUCxcbiAgICBib3R0b206ICc3MnB4JyxcbiAgICBsZWZ0OiAnMzJweCcsXG4gICAgW2Rlc2t0b3BGaXJzdE1lZGlhUXVlcnkudGFibGV0XToge1xuICAgICAgZGlzcGxheTogJ25vbmUnLFxuICAgIH0sXG4gIH0pO1xuIl19 */");
export {
  f as default
};
